if (!customElements.get('collection-list')) {
  class CollectionList extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        sliderWrapper: '.collection-list__items',
        pagination: '.swiper-pagination',
        nextEl: '.swiper-btn-next',
        prevEl: '.swiper-btn-prev',
      };
      this.classes = {
        grid: 'f-grid',
        swiper: 'swiper',
        swiperWrapper: 'swiper-wrapper',
      };

      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section-${this.sectionId}`);
      this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

      this.enableSlider = this.dataset.enableSlider === 'true';
      this.items = parseInt(this.dataset.items);
      this.tabletItems = parseInt(this.dataset.tabletItems);

      //added JRD 260127
this.autoRotateDelay = parseInt(this.dataset.autoplayDelay || '2500', 1500);
this._autoRotateTimeout = null;
this._isHovering = false;
this._hoverBound = false;

      //Added end

      this.sliderInstance = false;

      if (!this.enableSlider) return;

      this.init();
      document.addEventListener('matchMobile', () => {
        this.init();
      });
      document.addEventListener('unmatchMobile', () => {
        this.init();
      });
    }

    init() {
      if (FoxTheme.config.mqlMobile) {
        this.destroySlider();
      } else {
        this.initSlider();
      }
    }

    initSlider() {
      const columnGap = FoxTheme.utils.getGridColumnGap(this.sliderWrapper);

      const sliderOptions = {
        slidesPerView: this.tabletItems > 3 ? 3 : parseInt(this.tabletItems),
        spaceBetween: columnGap.tablet,
        navigation: {
          nextEl: this.section.querySelector(this.selectors.nextEl),
          prevEl: this.section.querySelector(this.selectors.prevEl),
        },
        pagination: false,
        breakpoints: {
          1024: {
            slidesPerView: parseInt(this.items),
            spaceBetween: columnGap.tabletLarge
          },
          1280: {
            slidesPerView: parseInt(this.items),
            spaceBetween: columnGap.desktop
          },
        },
        loop: true,
        threshold: 2,
      };

      if (typeof this.sliderInstance !== 'object') {
        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);
        this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
        this.sliderInstance.init();
//Added JRD 260127
      this.initAutoRotate();
//End added
        const focusableElements = FoxTheme.a11y.getFocusableElements(this);

        focusableElements.forEach((element) => {
          element.addEventListener('focusin', () => {
            const slide = element.closest('.swiper-slide');
            this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
          });
        });
      }

      if (Shopify.designMode && typeof this.sliderInstance === 'object') {
        document.addEventListener('shopify:block:select', (e) => {
          if (e.detail.sectionId != this.sectionId) return;
          let { target } = e;
          const index = Number(target.dataset.index);

          this.sliderInstance.slider.slideToLoop(index);
        });
      }
    }

    destroySlider() {
      //Added JRD 260127
      this.stopAutoRotate();
      //End added
      this.classList.remove(this.classes.swiper);
      this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
      this.sliderWrapper.classList.add(this.classes.grid);
      if (typeof this.sliderInstance === 'object') {
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }
    }

initAutoRotate() {
  // configure delay once
  this.autoRotateDelay = this.autoRotateDelay || 4000;

  // avoid rebinding on section reloads
  if (this._autoRotateInitDone) return;
  this._autoRotateInitDone = true;

  this._isHovering = false;

  this.addEventListener('mouseenter', () => (this._isHovering = true), { passive: true });
  this.addEventListener('mouseleave', () => (this._isHovering = false), { passive: true });

  this.startAutoRotate();
}

startAutoRotate() {
  this.stopAutoRotate();

  const swiper = this.sliderInstance?.slider;
  if (!swiper || swiper.destroyed) return;

  this._autoRotateRunning = true;

  const schedule = () => {
    if (!this._autoRotateRunning) return;
    clearTimeout(this._autoRotateTimeout);
    this._autoRotateTimeout = setTimeout(step, this.autoRotateDelay);
  };

  const step = () => {
    if (!this._autoRotateRunning) return;

    const s = this.sliderInstance?.slider;
    if (!s || s.destroyed) return;

    if (document.hidden || this._isHovering) return schedule();

    if (s.animating) {
      clearTimeout(this._autoRotateTimeout);
      this._autoRotateTimeout = setTimeout(step, 250);
      return;
    }

    // Compute REAL slide count (exclude loop clones)
    const looped = s.loopedSlides || 0;
    const realCount = s.slides.length - (2 * looped);

    // Guard
    if (!realCount || realCount <= 1) return schedule();

    // Next real slide, safely wrapped
    const nextReal = (s.realIndex + 1) % realCount;

    // Stabilize loop edges before moving
    if (typeof s.loopFix === 'function') s.loopFix({ direction: 'next' });

    // ✅ Advance in a loop-safe way (no clicking, no out-of-range)
    if (typeof s.slideToLoop === 'function') {
      s.slideToLoop(nextReal, s.params.speed || 1300, true);
    } else {
      // Fallback: jump to corresponding activeIndex (less ideal)
      s.slideNext(s.params.speed || 1300, true);
    }

    const onEnd = () => {
      s.off?.('slideChangeTransitionEnd', onEnd);
      if (typeof s.loopFix === 'function') s.loopFix({ direction: 'next' });
      schedule();
    };

    // bind once per step (and remove in handler)
    s.off?.('slideChangeTransitionEnd', onEnd);
    s.on?.('slideChangeTransitionEnd', onEnd);

    // safety if event doesn’t fire
    clearTimeout(this._autoRotateTimeout);
    this._autoRotateTimeout = setTimeout(() => {
      s.off?.('slideChangeTransitionEnd', onEnd);
      if (typeof s.loopFix === 'function') s.loopFix({ direction: 'next' });
      schedule();
    }, (s.params.speed || 1300) + 1200);
  };

  schedule();
}

stopAutoRotate() {
  this._autoRotateRunning = false;
  clearTimeout(this._autoRotateTimeout);
  this._autoRotateTimeout = null;

  const s = this.sliderInstance?.slider;
  // remove any leftover handler reference safety (no-op if not present)
  // (we used inline handler per step, so nothing persistent to remove)
}

  }
  customElements.define('collection-list', CollectionList);
}
